import { withInstall } from '/@/utils';
import fusionFilterComp from './index.vue'
export const FusionFilter = withInstall(fusionFilterComp);